import React from 'react';
import Icon from '../../../../components/AppIcon';

const FixedAssetMasterTab = () => {
  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
        <div>
          <h3 className="text-lg font-semibold text-gray-900">Fixed Asset Master</h3>
          <p className="text-gray-600">Manage fixed assets and depreciation</p>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
        <div className="text-center">
          <Icon name="Archive" size={64} className="mx-auto text-gray-400 mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">Fixed Asset Master Coming Soon</h3>
          <p className="text-gray-600 max-w-md mx-auto">
            Fixed asset management functionality is currently under development. This will allow you to track 
            fixed assets, calculate depreciation, and manage asset lifecycle.
          </p>
          <div className="mt-6">
            <span className="inline-flex items-center px-4 py-2 rounded-lg text-sm font-medium bg-blue-100 text-blue-800">
              <Icon name="Clock" size={16} className="mr-2" />
              Coming Soon
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FixedAssetMasterTab;